interface BreadcrumbProps {
  path: { id: string | null; name: string }[];
  currentFolderId: string | null;
  dragOverFolderId: string | null;
  onNavigate: (folderId: string | null) => void;
  onDragOver: (e: React.DragEvent, folderId: string | null) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent, folderId: string | null) => void;
}

export default function Breadcrumb({
  path,
  currentFolderId,
  dragOverFolderId,
  onNavigate,
  onDragOver,
  onDragLeave,
  onDrop,
}: BreadcrumbProps) {
  return (
    <nav className="flex items-center gap-1 text-sm py-2 overflow-x-auto" aria-label="폴더 경로">
      {path.map((item, index) => {
        const isLast = index === path.length - 1;
        const isDragTarget = !isLast && dragOverFolderId === item.id;
        const isRootDragTarget = !isLast && item.id === null && dragOverFolderId === null;

        return (
          <span key={item.id ?? 'root'} className="flex items-center gap-1 whitespace-nowrap">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {isLast ? (
              <span className="font-semibold text-foreground-900 px-2 py-0.5">
                {item.name}
              </span>
            ) : (
              <button
                onClick={() => onNavigate(item.id)}
                onDragOver={(e) => onDragOver(e, item.id)}
                onDragLeave={onDragLeave}
                onDrop={(e) => onDrop(e, item.id)}
                className={`text-foreground-600 hover:text-foreground-900 px-2 py-0.5 rounded-md transition-all duration-150 cursor-pointer ${
                  isDragTarget || isRootDragTarget
                    ? 'bg-accent-100 text-accent-700 ring-2 ring-accent-300 scale-105'
                    : 'hover:bg-background-200'
                }`}
              >
                {item.name}
                {(isDragTarget || isRootDragTarget) && (
                  <span className="inline-block ml-1.5">
                    <i className="ri-folder-transfer-line text-xs"></i>
                  </span>
                )}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}